<ngb-carousel *ngIf="showSlider()"
                yp-e2e-id="carousel"
                [showNavigationIndicators]="showPagination"
                [showNavigationArrows]="showNavigation"
>
  <ng-template ngbSlide *ngFor="let image of images; let i = index" >
    <div class="picsum-img-wrapper" [attr.yp-e2e-id]="'carousel-item-' + i">
      <img class="d-block w-100" [src]="image.thumbnails[thumbnailSize]" alt="">
    </div>
  </ng-template>
</ngb-carousel>

